// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function areaTypeV5_decode($$enum) {
  if ($$enum === "TOWNSHIP" || $$enum === "STATE" || $$enum === "SCHOOL_DISTRICT" || $$enum === "SCHOOL" || $$enum === "NEIGHBORHOOD" || $$enum === "COUNTY" || $$enum === "CITY" || $$enum === "CENSUS_PLACE" || $$enum === "BLOCK_GROUP" || $$enum === "ZIP_CODE") {
    return $$enum;
  }
  
}

function areaTypeV5_fromString(str) {
  return areaTypeV5_decode(str);
}

function matchableEntityType_decode($$enum) {
  if ($$enum === "RENTAL_NEED" || $$enum === "FOR_SALE_PROPERTY" || $$enum === "BUYER_NEED" || $$enum === "RENTAL_PROPERTY") {
    return $$enum;
  }
  
}

function matchableEntityType_fromString(str) {
  return matchableEntityType_decode(str);
}

var Utils = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: matchableEntityType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsPreferenceEditDialogAreaGroups_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserAreaGroup",
      "kind": "LinkedField",
      "name": "userAreaGroups",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usedFor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "areas",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "type_",
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              "action": "NONE"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
